import { computed } from "vue";
import { EBackgroundFit } from "../ts/enums/EBackgroundFit.js";
import { useImage } from "./useImageUrl.js";
export function useBackground(page, background) {
  const { image: apiBackground } = useImage(background, page);
  const backgroundFitMapping = {
    [EBackgroundFit.FILL]: "cover",
    [EBackgroundFit.FIT_WIDTH]: "contain"
  };
  const backgroundSize = background?.backgroundImageScale ? backgroundFitMapping[background?.backgroundImageScale] : "";
  const { mobile, tablet, desktop, original } = apiBackground || {};
  const getImageHref = (variant) => variant?.links?.site?.href || original?.links?.site?.href;
  const backgroundProperties = {
    backgroundColor: background?.backgroundColor,
    backgroundSize,
    mobile: getImageHref(mobile),
    tablet: getImageHref(tablet),
    desktop: getImageHref(desktop)
  };
  const backgroundStyles = computed(() => ({
    background: background?.backgroundColor,
    backgroundImage: `url('${getImageHref(apiBackground?.original)}')`,
    backgroundSize: background?.backgroundImageScale ? backgroundFitMapping[background?.backgroundImageScale] : ""
  }));
  return { backgroundStyles, backgroundProperties };
}
